
import { defineComponent, inject, ref } from "vue";
import { postEditPassword } from "@/api/http";
export default defineComponent({
    name: "Password",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["修改密码"]);
        let form = ref({
                primary_password: "",
                new_password: "",
                confirm_password: "",
            }),
            formRef = ref(null);
        const rules = {
            primary_password: [
                {
                    required: true,
                    message: "请输入原密码",
                    trigger: "change",
                },
            ],
            new_password: [
                {
                    required: true,
                    message: "请输入新密码",
                    trigger: "change",
                },
            ],
            confirm_password: [
                {
                    required: true,
                    validator: (
                        rule: any,
                        value: string,
                        callback: Function
                    ) => {
                        if (value != form.value.new_password) {
                            callback(new Error("两次密码不一致"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change",
                },
            ],
        },
        passwordChange = () => {
            (formRef.value as any).validate((valid: boolean) => {
                if (valid) {
                    postEditPassword(form.value).then((res) => {
                        if (res.status == 202) {
                            form.value = {
                                primary_password: "",
                                new_password: "",
                                confirm_password: "",
                            };
                        }
                    });
                }
            });
        };
        return {
            form,
            formRef,
            rules,
            passwordChange,
        };
    },
});
